
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4NH0a5Ct1tIcHY7l0ylhYVMTTobJVcLUHZnL68degeEMeta } from "/opt/build/repo/client/pages/index.vue?macro=true";
import { default as _91_46_46_46all_93RtjcFd8ueTYmtBPkplQheyYQaUaQCTb0Jru9yy4dNhIMeta } from "/opt/build/repo/client/pages/[...all].vue?macro=true";
import { default as index_5a_ULfQV_dRzL1tCk4UpzqAYLHaKB_45c6_45touiIICWwMeta } from "/opt/build/repo/client/pages/events/index.vue?macro=true";
import { default as createi_45Z3DMsJJG6Hd11bVIuqdtNpF1iXeItRE39Ystgw2nwMeta } from "/opt/build/repo/client/pages/events/create.vue?macro=true";
import { default as indexw8Q92544HwiKVdspzi2c_45_jb9hVtrSV2E6jWl_1BfPcMeta } from "/opt/build/repo/client/pages/planner/index.vue?macro=true";
import { default as indexhfEFDHJp9nLI3aZ94CbiK8bARc_45B3rh5etIBn6QQngYMeta } from "/opt/build/repo/client/pages/audience/index.vue?macro=true";
import { default as indexJzDcfeHEIrdEDO7sxxz6GXCt9kpOTPAIAkW26Bo0ipMMeta } from "/opt/build/repo/client/pages/messages/index.vue?macro=true";
import { default as indexCjM7tkT0JtmTclESDv_Eom_8gray5ZXMR9Bvy_455TWg4Meta } from "/opt/build/repo/client/pages/campaigns/index.vue?macro=true";
import { default as create1yEIrX7UJPMeqnKWoDDy6OFwaXT_45Gu0RtXye8nq0LcUMeta } from "/opt/build/repo/client/pages/messages/create.vue?macro=true";
import { default as createAOuM1S8w4GNWsR_tIhqKoCN1PA2QzoJLYLG3gDZVaIYMeta } from "/opt/build/repo/client/pages/campaigns/create.vue?macro=true";
import { default as indexlBMUvBK2X7umd_mA___Zpcc_45Kxzkq63D3vxatrRxksMMeta } from "/opt/build/repo/client/pages/events/past/index.vue?macro=true";
import { default as loginpNnDb3CCwZfGwXK5GozOtiozD4UzXPdu8yAr5u9vl3MMeta } from "/opt/build/repo/client/pages/authenticate/login.vue?macro=true";
import { default as indexP2IaNRmvkGEho3CFtWTdaR6LlLnJMpowGLXrtAe3Nk0Meta } from "/opt/build/repo/client/pages/audience/tags/index.vue?macro=true";
import { default as signupet6ZHX2xhHi1xJfPKKN7oXPPWID_45G9G84JDHuFrSk3YMeta } from "/opt/build/repo/client/pages/authenticate/signup.vue?macro=true";
import { default as viewMkC40uhMa_Ll0PKPUeQnOkxQIRkZmmGQK1OcE_g_450rMMeta } from "/opt/build/repo/client/pages/messages/[oid]/view.vue?macro=true";
import { default as _91oid_93bWPNCuTu0xIefjoRvzau7S0bHEn8wUOg0Ld9_2M1hlIMeta } from "/opt/build/repo/client/pages/campaigns/view/[oid].vue?macro=true";
import { default as indexFGIKYpzDbKEyDLUK9ayA1zT3X6JzW8l0S2Qwe8PZLf8Meta } from "/opt/build/repo/client/pages/custom-planner/index.vue?macro=true";
import { default as indexc8JjJ4W2ycjvJDEk4yu_uwCdenSfAbLq5LqcyrOwKT4Meta } from "/opt/build/repo/client/pages/messages/lists/index.vue?macro=true";
import { default as indexZWKUYPVH_45eszHe34lNkocO9kgN2O2CvfLnl5NTwd_458AMeta } from "/opt/build/repo/client/pages/events/archived/index.vue?macro=true";
import { default as indexilP_45C70ah4VTXiulsZpq8Xgxr9HJlyQ_7_45oXp9A11woMeta } from "/opt/build/repo/client/pages/audience/filters/index.vue?macro=true";
import { default as _91oid_93u6hv6ZNBgX1bsH_DMY4K9o8KBH3IpHz56pJlkLuC_45r4Meta } from "/opt/build/repo/client/pages/campaigns/update/[oid].vue?macro=true";
import { default as signupsecU_45b_ojpKZEqVm4_45AKN6gZyebrsFKpSpfndM96FNy0Meta } from "/opt/build/repo/client/pages/campaigns/view/signups.vue?macro=true";
import { default as edit1tWbBc5SxN5YurimnTpVM7pfgiqShWpxLA2SGTQGEGEMeta } from "/opt/build/repo/client/pages/events/[eventoid]/edit.vue?macro=true";
import { default as email_45exampleViSrKFK7VjCD_I_45DcY3kqzqqiAI4skOk8uFe6Ru_6EQMeta } from "/opt/build/repo/client/pages/campaigns/email-example.vue?macro=true";
import { default as insightsyFwAelsGR26QKZ6hVWFXqzbG_vUs09_Dev6iQEv8_7UMeta } from "/opt/build/repo/client/pages/campaigns/view/insights.vue?macro=true";
import { default as indexK6eIPOL6lwvZlJJdvrI4HfGk_RP8PrDVXmETWCLW03AMeta } from "/opt/build/repo/client/pages/events/composables/index.ts?macro=true";
import { default as dashboardhj29vbf87fTysetvHcMpfPzcDtBv3ZyBMJ8yKJ_45H2BgMeta } from "/opt/build/repo/client/pages/campaigns/view/dashboard.vue?macro=true";
import { default as index0hGKDUIzFA3BDViq_45RIdGnvkJbQtdVM5NTzcs0Hgk_oMeta } from "/opt/build/repo/client/pages/messages/templates/index.vue?macro=true";
import { default as email_45verifyhsK2eOhgswWAJU9W4irNZzAbqWiPxWvp0FH6yOvekgoMeta } from "/opt/build/repo/client/pages/authenticate/email-verify.vue?macro=true";
import { default as indexBC5de3UcUPUEs5fflfm1tfWTYDMfUt6HhRQrypq8x_cMeta } from "/opt/build/repo/client/pages/authenticate/invite/index.vue?macro=true";
import { default as calendarItems3JL7RgVm529WHuHVd_45KhSI_458fk8J9psZNyWSFl3UjPoMeta } from "/opt/build/repo/client/pages/events/types/calendarItems.ts?macro=true";
import { default as criteriaMenu1Cws_0GXTZfVRABrY4FZ7PfGt1gNZNgJgO8ZOU58jfcMeta } from "/opt/build/repo/client/pages/audience/utils/criteriaMenu.js?macro=true";
import { default as filterNaming4Q9f_45X6ytYcztiWAmQcdJxzKbksIHIFBQJfEM7MHtaYMeta } from "/opt/build/repo/client/pages/audience/utils/filterNaming.ts?macro=true";
import { default as ResetPasswordOeXYUsui3mnNcwze4W1Og_ibPLKCl6CmVuu6p8KJMbMMeta } from "/opt/build/repo/client/pages/authenticate/ResetPassword.vue?macro=true";
import { default as billing_45detailscD5_45_RKMpm837Fw_45Tjv1ENDCvIfuKsyCI2mITw57SNwMeta } from "/opt/build/repo/client/pages/authenticate/billing-details.vue?macro=true";
import { default as forgot_45passwordToFP_FeGrP5H_450mf9okKoyk_455jyZC7bknJb_fA4vJd0Meta } from "/opt/build/repo/client/pages/authenticate/forgot-password.vue?macro=true";
import { default as registrationsV5_imWKAdd6V8Awsx1BJElqzX1SMMR3LtmYJiet2cXEMeta } from "/opt/build/repo/client/pages/campaigns/view/registrations.vue?macro=true";
import { default as eventgPuOz4kMsH8s2g24RqSg7_lo8uhWodjT1opThShqWc4Meta } from "/opt/build/repo/client/pages/events/[eventoid]/view/event.vue?macro=true";
import { default as groupXaAmG6e6f0YBhHnKTVqpar3Rch4_M2BWz0gnDiHbn6kMeta } from "/opt/build/repo/client/pages/events/[eventoid]/view/group.vue?macro=true";
import { default as data_45capture_45exampleKAm4KUPFNkWJmZ6KFsIuBPtI5eNzXqS_457TRZOs1zWMwMeta } from "/opt/build/repo/client/pages/audience/data-capture-example.vue?macro=true";
import { default as indexIedonksVI73YAJZx6By_451_DZScv3IqsqVKgzp3vcfo8Meta } from "/opt/build/repo/client/pages/audience/[customer]/view/index.vue?macro=true";
import { default as FilterTabs8Yg5Dlu3HXFV0qgsHnnoSBOIwC9Gii1rTBRs4s_OUpUMeta } from "/opt/build/repo/client/pages/audience/components/FilterTabs.vue?macro=true";
import { default as import_45sales_45dataFIYzYOo3ECIxI8u3cMYk1JfJ2rbrxNNMem5HkV6lJbMMeta } from "/opt/build/repo/client/pages/authenticate/import-sales-data.vue?macro=true";
import { default as indexrOI_45PbfmKw4vazIROIisbA15xW87C8p_iNfqIpEzupgMeta } from "/opt/build/repo/client/pages/authenticate/invite-sent/index.vue?macro=true";
import { default as useSmsCostwS_45_Y2KNcqERXYFHOfPTOY9RWHVU1Ub_45GXXUVsHhPqkMeta } from "/opt/build/repo/client/pages/messages/composables/useSmsCost.ts?macro=true";
import { default as useMessagesXw8ocAacTVqX11tbU9sXYoEqYCezqBBZkc_t5MWdKwQMeta } from "/opt/build/repo/client/pages/messages/composables/useMessages.ts?macro=true";
import { default as useSendTimeZDrRqIGK1DBvtpRAo9WzvBsyuVOJzi5xtZxlL6j8sPsMeta } from "/opt/build/repo/client/pages/messages/composables/useSendTime.ts?macro=true";
import { default as utilsMessageListsnQz7Ri_45dh7OnZUN4sNwYSgW486W044UUMzyLbW4eCXgMeta } from "/opt/build/repo/client/pages/messages/utils/utilsMessageLists.ts?macro=true";
import { default as EditEventGroupmSBUGlDBrf1ekkc4TYf9CkLN1YBEVposoV_45M6roQ6isMeta } from "/opt/build/repo/client/pages/events/components/EditEventGroup.vue?macro=true";
import { default as OrdersTabgZKUEyL0ZHWQ73QPQm3fvwHQrJ1gf_45_dH7jRI8ZK_eUMeta } from "/opt/build/repo/client/pages/events/components/view/OrdersTab.vue?macro=true";
import { default as MessagesList8VvRtIalu3J6g_ptgWYwCITJaoM_45v6_7kAswfGswxV0Meta } from "/opt/build/repo/client/pages/messages/components/MessagesList.vue?macro=true";
import { default as messageNames_45sSC9G_45fVna6AzD_9M_455VFvEbUMy9jgPsfapPkxAe18Meta } from "/opt/build/repo/client/pages/messages/composables/messageNames.ts?macro=true";
import { default as FilterTagListDtZtLm3JdqdkkrOzcLsJ3PIj0RJez4eUAqXOJ_45CvIkgMeta } from "/opt/build/repo/client/pages/audience/components/FilterTagList.vue?macro=true";
import { default as conditionCompletionaz8dai4AAynojRTFnHpxZ4t8iuaoeH63RA0inUag_mUMeta } from "/opt/build/repo/client/pages/audience/utils/conditionCompletion.ts?macro=true";
import { default as index1_455DaNYoyPFE0Ew5cEjbH3QwJf05tTUKf5H4py2dyKoMeta } from "/opt/build/repo/client/pages/authenticate/invite-expired/index.vue?macro=true";
import { default as campaignsQo_e4QPhjaTkCPDjetO1IDwlo1MUguEp6TOPQM9tgM0Meta } from "/opt/build/repo/client/pages/audience/[customer]/view/campaigns.vue?macro=true";
import { default as FavoriteButtonqJBuhaYIVl68Qz_QMYXWeo_459soGPPAAYU_g2x_45jz5BMMeta } from "/opt/build/repo/client/pages/audience/components/FavoriteButton.vue?macro=true";
import { default as FilterListItem_45J2S5qVgnoW_45j4rYZ7g293VVxUGA_D5xgXBbe6Vooj0Meta } from "/opt/build/repo/client/pages/audience/components/FilterListItem.vue?macro=true";
import { default as useTagCreationAC1uWtTK4sMSF3YgkMOrC67I6HlFzZtvMviw_45Ub1xRoMeta } from "/opt/build/repo/client/pages/audience/composables/useTagCreation.js?macro=true";
import { default as GroupEventsModalL_45f4e1pQcGEGVKlN8p5lxXkD9swwuuG3bQDyc3xutmYMeta } from "/opt/build/repo/client/pages/events/components/GroupEventsModal.vue?macro=true";
import { default as InsightsTab34VUYIEgWtNlAZpWRYGNRT_45L7Ig4lBsvRZsXYU7DqVAMeta } from "/opt/build/repo/client/pages/events/components/view/InsightsTab.vue?macro=true";
import { default as MessagesTaba4YxqBWznw_45noQG_PjgwkWxEs3zl2ATnEPITsA2YKioMeta } from "/opt/build/repo/client/pages/events/components/view/MessagesTab.vue?macro=true";
import { default as useEventMessagesagqi1RbaSDgTZt1AoqqZ0Mxqa_DOBZ09sdCbA1W4g8QMeta } from "/opt/build/repo/client/pages/events/composables/useEventMessages.ts?macro=true";
import { default as MessageSmsCost0KGNDeD1eT85Yicidi91yzgJ8OMJAXsCYhrA9J6go5YMeta } from "/opt/build/repo/client/pages/messages/components/MessageSmsCost.vue?macro=true";
import { default as messageActionsHiOAbokOoP7Wo6cUul8RljuG_y45p1vtJfmExMXZQSsMeta } from "/opt/build/repo/client/pages/messages/composables/messageActions.ts?macro=true";
import { default as messageResultsryYMFbME0PSfUyK7kERAr1t03kxgbWFy_2NaKEGcmm0Meta } from "/opt/build/repo/client/pages/messages/composables/messageResults.ts?macro=true";
import { default as useEmailDesignXHKehdT4blmsvZcs_4516e1jV3_45id5EARYyF83AUCRLKcMeta } from "/opt/build/repo/client/pages/messages/composables/useEmailDesign.ts?macro=true";
import { default as useLinkedEventlXt0x5Uc4auFOZp_Lo2QCSgMltqRDZoC2zigYWpIXWsMeta } from "/opt/build/repo/client/pages/messages/composables/useLinkedEvent.ts?macro=true";
import { default as AudienceFiltersggHc8yYtTDgw7RprNw4EDZINfRYfkkveN_kHdi27QX8Meta } from "/opt/build/repo/client/pages/audience/components/AudienceFilters.vue?macro=true";
import { default as AddActionModalOS_45wBzHtdM6XTsIn9LFTG9kASK5y_45iGhV2RjEFBIdiIMeta } from "/opt/build/repo/client/pages/campaigns/components/AddActionModal.vue?macro=true";
import { default as AddRewardModala4_453rEAMtkstNXqQ51AcdjO65sEWzckF2U0VYsR_455BgMeta } from "/opt/build/repo/client/pages/campaigns/components/AddRewardModal.vue?macro=true";
import { default as EditFieldModaljh8m9DGszZ0dr_45LMNYWXTak__IH6rkaMsrtNR79t4Q8Meta } from "/opt/build/repo/client/pages/campaigns/components/EditFieldModal.vue?macro=true";
import { default as DeleteEventsModal1oaVpFAxDqzwCT5xJPU3lG_ckUNBbXpPZMIJTRrbzS0Meta } from "/opt/build/repo/client/pages/events/components/DeleteEventsModal.vue?macro=true";
import { default as ImportEventsModal0FBQMXo0D9q75l3_CmYCmwAz5qbfCEH_ZQw82R8PgIkMeta } from "/opt/build/repo/client/pages/events/components/ImportEventsModal.vue?macro=true";
import { default as useEventCampaignsni9MDBSHD3ZiICnjf9BvvWk_450xW8k8QmyY6MxIBJxu8Meta } from "/opt/build/repo/client/pages/events/composables/useEventCampaigns.ts?macro=true";
import { default as ImportHtmlModalOK5WB9rULFyE7OINiumdXK8C4VmWrGDOaltqHAcvN_sMeta } from "/opt/build/repo/client/pages/messages/components/ImportHtmlModal.vue?macro=true";
import { default as MessagesToolbarnaC0exoOEXWnxKy7cVDFtRJRsC_45Dy_45V4Z9DigOwP9E4Meta } from "/opt/build/repo/client/pages/messages/components/MessagesToolbar.vue?macro=true";
import { default as draftCompletion9uWatN_45jL2xnGo_459WwNgiv6waxPGA0WGfAMGvT3uT4oMeta } from "/opt/build/repo/client/pages/messages/composables/draftCompletion.ts?macro=true";
import { default as PlannerDayDrawerIfFhSaI_45SBldtonvC004rA8wJIjThYER9cyFT_D2rLwMeta } from "/opt/build/repo/client/pages/planner/components/PlannerDayDrawer.vue?macro=true";
import { default as ContactFormModal_f089Y5ACCnpFhfZLxohoZSt8m1CaSf_VYiLI79zzesMeta } from "/opt/build/repo/client/pages/audience/components/ContactFormModal.vue?macro=true";
import { default as EditFanTagsModaleG6tK7g5dZOf0Z_45O3xplAvZTeepz7a7A465je0ltA2QMeta } from "/opt/build/repo/client/pages/audience/components/EditFanTagsModal.vue?macro=true";
import { default as FanMassEditModalRA0ldbDTBEl8eSSDAgfx3oWpXaCwl5G068t53i5wbXUMeta } from "/opt/build/repo/client/pages/audience/components/FanMassEditModal.vue?macro=true";
import { default as useActiveFiltersLNve0TfIN_nRyaQ1R0LBUt0xrHPR5F5V88U25z_eXi0Meta } from "/opt/build/repo/client/pages/audience/composables/useActiveFilters.js?macro=true";
import { default as connect_45cardNiezUZPTxsRPNO0vgjTK1SninWw0mImsGgK5GKHuDXgMeta } from "/opt/build/repo/client/pages/authenticate/components/connect-card.vue?macro=true";
import { default as EditActionModalk7doroxO3CTCLVbh0U7NFthSiFXKHg94QNGdiAd5rSEMeta } from "/opt/build/repo/client/pages/campaigns/components/EditActionModal.vue?macro=true";
import { default as EditButtonModalYsjg1p8JsDW_45E1fesRP7xcFM5O_Mt5el2ZcyuxOPMg0Meta } from "/opt/build/repo/client/pages/campaigns/components/EditButtonModal.vue?macro=true";
import { default as useGamificationfrZf2bm2PKXO9XJr2n85iLz8vEjXOviP18JGGDfAGLwMeta } from "/opt/build/repo/client/pages/campaigns/composables/useGamification.js?macro=true";
import { default as ArchiveEventsModalJ0BONJSvPeQ9s3f33XJ4OxEmzotO790x9KbJ3hOLI_45AMeta } from "/opt/build/repo/client/pages/events/components/ArchiveEventsModal.vue?macro=true";
import { default as MessagesOverviewv61S_4H8YKBBD75nT9APi4iJiFiSLCAfuOz_h374h_YMeta } from "/opt/build/repo/client/pages/messages/components/MessagesOverview.vue?macro=true";
import { default as MessagesStatsBarLAMJdl1S3dVGJIXAJvChr47pjchf35E54M2nHs_OYZAMeta } from "/opt/build/repo/client/pages/messages/components/MessagesStatsBar.vue?macro=true";
import { default as useBeefreeEditor5X_Uyt1j9JyAqde7_45PkI8H5JZ3nM6YyG0EBmfDc86jcMeta } from "/opt/build/repo/client/pages/messages/composables/useBeefreeEditor.ts?macro=true";
import { default as useSenderDetailsfK43dgF_vZvI3mFja0Q1uGRBIsMzvKbeiJtGw7uWvTAMeta } from "/opt/build/repo/client/pages/messages/composables/useSenderDetails.ts?macro=true";
import { default as posPurchasesnyc7oNZbTuN2GQr2j9UVWjZ4F2VPWQNhnrnFlWWW9jMMeta } from "/opt/build/repo/client/pages/audience/[customer]/view/posPurchases.vue?macro=true";
import { default as useContactColumnsXF3m_U30gq50l9_45AEnq7AA0VzmVtNIarSXsn6EI5n6UMeta } from "/opt/build/repo/client/pages/audience/composables/useContactColumns.ts?macro=true";
import { default as AdvancedSettingsxeUSet2PO2Z5wbQCACyfmhYTTKrbu5WHSwfcg_45FpF30Meta } from "/opt/build/repo/client/pages/campaigns/components/AdvancedSettings.vue?macro=true";
import { default as useCampaignLogicC5KpCUxv5aA947MPTT_45rDaNqAsDmgd_45Bdrv90Nco_xMMeta } from "/opt/build/repo/client/pages/campaigns/composables/useCampaignLogic.js?macro=true";
import { default as DataCaptureTabDWBnGP6TuAipow_45KBZICpBFBIwNaWFRhmu9NelB7gZwMeta } from "/opt/build/repo/client/pages/events/components/view/DataCaptureTab.vue?macro=true";
import { default as TicketSalesTab6n_XvzXXnXEIaIyCeDG62YIt5wAetmYeIVSqKnS4MzQMeta } from "/opt/build/repo/client/pages/events/components/view/TicketSalesTab.vue?macro=true";
import { default as utilsDistribution7gGpfkAQAgs0_5S1QFq15RBgLqzcX8oqQyseefI79HkMeta } from "/opt/build/repo/client/pages/messages/[oid]/utils/utilsDistribution.ts?macro=true";
import { default as utilsMessageStatsvr7vAaDpY2Xzd_45YthY0fq0e8vJ1WrQ05NnBGG4OGbBEMeta } from "/opt/build/repo/client/pages/messages/[oid]/utils/utilsMessageStats.ts?macro=true";
import { default as utilsSmsCountriesnUWA2F9s1TooFtyAV9zMq0SXSp9sOlRmlL6ZavjozSAMeta } from "/opt/build/repo/client/pages/messages/[oid]/utils/utilsSmsCountries.ts?macro=true";
import { default as MessageSmsPreviewTWWWiBSeSuTcxhbmUzfxuTSeCogBqtP3JHMEu_45xiaKcMeta } from "/opt/build/repo/client/pages/messages/components/MessageSmsPreview.vue?macro=true";
import { default as SaveTemplateModaltMhz_452x0rK64_OBxK08HINT86sLaJjIlCiaBgucd9H0Meta } from "/opt/build/repo/client/pages/messages/components/SaveTemplateModal.vue?macro=true";
import { default as messageStatusInfoZyVg_CFgNC4N3fHj4gdVN_mPfUcm7PV8PIhxwDzsiGEMeta } from "/opt/build/repo/client/pages/messages/composables/messageStatusInfo.ts?macro=true";
import { default as FanMassDeleteModalusqbf619tV4Um3w6o72yc9iezO_45jMVGz4IZeyNlAvvwMeta } from "/opt/build/repo/client/pages/audience/components/FanMassDeleteModal.vue?macro=true";
import { default as useAdvancedFiltersNt7yGQc6Z9vDQYqIi7yhsqT1_45htNrArAPTa_dMtaTGMMeta } from "/opt/build/repo/client/pages/audience/composables/useAdvancedFilters.js?macro=true";
import { default as useResourceOptionsJmbSerOw8rildUc02uo4f9jeopxJFgWiAHwIS2bR3QIMeta } from "/opt/build/repo/client/pages/audience/composables/useResourceOptions.js?macro=true";
import { default as EditCheckboxModalSRFYBJClL0EtAMexs_pxIDaNHZcROyOJr0MkHNfF6U4Meta } from "/opt/build/repo/client/pages/campaigns/components/EditCheckboxModal.vue?macro=true";
import { default as GamificationStatsAfaAvk9q68DXpcQhxdvO8tw7oqpPNhhetcWWUjYvxn4Meta } from "/opt/build/repo/client/pages/campaigns/components/GamificationStats.vue?macro=true";
import { default as RedirectDelayCards1N3gfkcAVnWu0AJDRmOJ7Q6VwEbgAIq1f8lxCRlTGMMeta } from "/opt/build/repo/client/pages/campaigns/components/RedirectDelayCard.vue?macro=true";
import { default as DuplicateEventsModalgsIWc9DjTDJ1GyiVgmr_q89F_17hSxhfuLvalyvh0sIMeta } from "/opt/build/repo/client/pages/events/components/DuplicateEventsModal.vue?macro=true";
import { default as useEventDataCapturesUsWeQHTeb3zICHNQUUL96tyh37P1bDX3NeDyQYnbT8YMeta } from "/opt/build/repo/client/pages/events/composables/useEventDataCaptures.ts?macro=true";
import { default as useMarketingCalendar54W1phl_45PdyW3LkvY2Q8qbBXdcLn42O7_7msZqR_5GIMeta } from "/opt/build/repo/client/pages/events/composables/useMarketingCalendar.ts?macro=true";
import { default as TopLinksCardZ_45bb2LPgwTkAG5lGR825k4Tl4Iv3HkxlAAAFKVDXAQwMeta } from "/opt/build/repo/client/pages/messages/[oid]/components/TopLinksCard.vue?macro=true";
import { default as useShortUrlsMwd2l_BZDrMLTJ_IUhtbLZKKmvSRUjk0Rh1rBexOjToMeta } from "/opt/build/repo/client/pages/messages/[oid]/composables/useShortUrls.ts?macro=true";
import { default as BeefreeEmailEditorTab3jZUr8PsNDIThGvcI9Wffn_DgWQAdvJGy7Se6jAcMeta } from "/opt/build/repo/client/pages/messages/components/BeefreeEmailEditor.vue?macro=true";
import { default as BeefreeEventDialogccMy2LYW3s9Leh2aZB2UYHIsWN7MgqkGluDEKqAsywYMeta } from "/opt/build/repo/client/pages/messages/components/BeefreeEventDialog.vue?macro=true";
import { default as MessageLinkedEventsWS4ZZ1VEmMoI7D1L6LTmSu1pDm_45_45T3bnD2oEd6AfKAMeta } from "/opt/build/repo/client/pages/messages/components/MessageLinkedEvent.vue?macro=true";
import { default as useExportDateRangevC7DcnpB7_459DIq_9r4eg9_45loUEdYviRrNxjLldZ6UG4Meta } from "/opt/build/repo/client/pages/messages/composables/useExportDateRange.ts?macro=true";
import { default as useMessagesFiltersqfOQT1g2eYlU1YG7vcSNwSgQeJw_4586pxOkieEcy3Rd8Meta } from "/opt/build/repo/client/pages/messages/composables/useMessagesFilters.ts?macro=true";
import { default as useMessagesLookupsSTRR2SK6Wc28FiMaZKYgFsApMF5CGgl7dj8tZXREZ_45QMeta } from "/opt/build/repo/client/pages/messages/composables/useMessagesLookups.ts?macro=true";
import { default as AudienceFilterGroupigYUxBp_45Pm8GE_B7jgGRWlrFCvuha6tDFXgJfyEg2MgMeta } from "/opt/build/repo/client/pages/audience/components/AudienceFilterGroup.vue?macro=true";
import { default as useResourceFetchersWvKMJrN5HYRZHkxs_45LulfeRerv1pewTdbZ5B9A7FKpgMeta } from "/opt/build/repo/client/pages/audience/composables/useResourceFetchers.js?macro=true";
import { default as GroupTagsModalHpvhfRVdeJsIHZzaknjn8tSkzQnZ4SL5aWMAVwjxTQEMeta } from "/opt/build/repo/client/pages/audience/tags/components/GroupTagsModal.vue?macro=true";
import { default as MergeTagsModals_2jnCPk6xGQ2TWO5XLFKyH3KxvtIFF7HN0Qjj7bsUoMeta } from "/opt/build/repo/client/pages/audience/tags/components/MergeTagsModal.vue?macro=true";
import { default as DesktopLayoutModal2OyEfTvUQcZoD1TpE8jAMlVZKuiEFxP1ZADgHHySs0cMeta } from "/opt/build/repo/client/pages/campaigns/components/DesktopLayoutModal.vue?macro=true";
import { default as InviteFriendsModal7bIrJCRaXSiqigywpdOaAT4Pdqa6_455Wd43Uk5uWc41sMeta } from "/opt/build/repo/client/pages/campaigns/components/InviteFriendsModal.vue?macro=true";
import { default as useCampaignActionspAItzwpnGWGSFWI5WbASgRwQac8NZBtbPB3_450Tz4zbUMeta } from "/opt/build/repo/client/pages/campaigns/composables/useCampaignActions.ts?macro=true";
import { default as useEventCustomEntries__45ox_pUGqjWe8D_Va1ypcTTH6jlpZBCJ_iNrSX4KyL8Meta } from "/opt/build/repo/client/pages/events/composables/useEventCustomEntries.ts?macro=true";
import { default as CreateMessageDrawer_45yIHfmLdD_kNnsu5KG8dlyfwb3C4dbr9jsDZq_45WGGVwMeta } from "/opt/build/repo/client/pages/messages/components/CreateMessageDrawer.vue?macro=true";
import { default as MessageEmailBuilderAU3_45AQITpBnyMzucta_45c_45RumL5VLj4D1dI6SL9iO0e8Meta } from "/opt/build/repo/client/pages/messages/components/MessageEmailBuilder.vue?macro=true";
import { default as MessageEmailPreview_a8WYYgkhCvkaI19iWtebniEDiU0FpmH_45rzumrdfNScMeta } from "/opt/build/repo/client/pages/messages/components/MessageEmailPreview.vue?macro=true";
import { default as MessageSendTimeStep5qWSOnzbLT41QbnuPVYfvZ_45RtC6PEZKlj2A_45y074QaEMeta } from "/opt/build/repo/client/pages/messages/components/MessageSendTimeStep.vue?macro=true";
import { default as ticketPurchasesTEDhWRz2b7Hnyigevt4w3mPuHN79L1JAFEnbXDOGCNUMeta } from "/opt/build/repo/client/pages/audience/[customer]/view/ticketPurchases.vue?macro=true";
import { default as useFilterCompressionedVCuROyYNDSLTb3mTfZjD9p2GIYI33lOEVfjVG3_a8Meta } from "/opt/build/repo/client/pages/audience/composables/useFilterCompression.ts?macro=true";
import { default as DeleteTagsModalRuqiJsFeVy8KWw2oWBil52kHa77kA9pg06RaQl4J6gcMeta } from "/opt/build/repo/client/pages/audience/tags/components/DeleteTagsModal.vue?macro=true";
import { default as RenameTagsModalThLvZv8NptWN7vI7wzB7ct3c_pHCti6YN_3S4H0lT1sMeta } from "/opt/build/repo/client/pages/audience/tags/components/RenameTagsModal.vue?macro=true";
import { default as AddCustomFieldModalIFtCYgtq4rAP_ijmwsFYGNHRS81dqbZ6DQJqWm6r6rkMeta } from "/opt/build/repo/client/pages/campaigns/components/AddCustomFieldModal.vue?macro=true";
import { default as DeleteCampaignModalmILQNEyNu_uO1Ie4sYbL1OqIeDyM_FErdeCyIe7__vMMeta } from "/opt/build/repo/client/pages/campaigns/components/DeleteCampaignModal.vue?macro=true";
import { default as ClearTicketOrdersModal4snSG389QEa2EDryhy_DEd0gShYnvmhcb_IoV6wP0hkMeta } from "/opt/build/repo/client/pages/events/components/ClearTicketOrdersModal.vue?macro=true";
import { default as useMessageView_45xW4HhM4t4v59iGs7QdiaCs0NNMQL221swFfguB2G_oMeta } from "/opt/build/repo/client/pages/messages/[oid]/composables/useMessageView.ts?macro=true";
import { default as utilsConversionStatsnT6H_uHcOgkG4INtgb0th1yOKlm1IkK7jGDyUkx7_45d0Meta } from "/opt/build/repo/client/pages/messages/[oid]/utils/utilsConversionStats.ts?macro=true";
import { default as MessagesConfirmModalf7pYocyMfaCfbo2JMAFY6jbu3XpTDgOFXP_45pMHM_iD8Meta } from "/opt/build/repo/client/pages/messages/components/MessagesConfirmModal.vue?macro=true";
import { default as messagesFeatureFlagsydBZjqlTauY3crfu4uP1FrDW4VtlehgY8PNhG5gPSRgMeta } from "/opt/build/repo/client/pages/messages/composables/messagesFeatureFlags.ts?macro=true";
import { default as useMessageEditDrawerxwsoa8DF7v8MzayD28IkL5Wq61FFheFnfh2_q9_b3YIMeta } from "/opt/build/repo/client/pages/messages/composables/useMessageEditDrawer.ts?macro=true";
import { default as FilterConstraintInputww8c_45aJbzkRiXlhrqVLR5n20tg7oXGl_450cAuaqDGKyIMeta } from "/opt/build/repo/client/pages/audience/components/FilterConstraintInput.vue?macro=true";
import { default as CampaignPreviewFrameIkOKSOyvI_45erqEFKr5WbXN0BxaWm9XFnTIlCKmZnb3sMeta } from "/opt/build/repo/client/pages/campaigns/components/CampaignPreviewFrame.vue?macro=true";
import { default as CampaignTypeSelectorNw0OO8yCR6fbvj_6LlieS81NLxhZmvlneuePsQZ222IMeta } from "/opt/build/repo/client/pages/campaigns/components/CampaignTypeSelector.vue?macro=true";
import { default as ImportTicketOrdersModallLMonV_45JWJXUy0JIb1PX41vk8zJx9BcPRiQjqoZuMv0Meta } from "/opt/build/repo/client/pages/events/components/ImportTicketOrdersModal.vue?macro=true";
import { default as ConversionChartQUibxkKoxaK7fbEKfNCKMInak9USvBVtoz3txfsR7XEMeta } from "/opt/build/repo/client/pages/messages/[oid]/components/ConversionChart.vue?macro=true";
import { default as ConversionTableGwDOVZ9w4NCe49ETheEmPHnMy5es5s3c31ePQONU4xAMeta } from "/opt/build/repo/client/pages/messages/[oid]/components/ConversionTable.vue?macro=true";
import { default as useMessageStatsw0ih6wcZOWsM3I_wAaHfN0rxq6cntWY_MU2ziKc4nSUMeta } from "/opt/build/repo/client/pages/messages/[oid]/composables/useMessageStats.ts?macro=true";
import { default as utilsRecipientsViewByMrgs8P3aatCQFXBT_r_C1csiLUyE_45lOkw_lLzxeQbJgMeta } from "/opt/build/repo/client/pages/messages/[oid]/utils/utilsRecipientsViewBy.ts?macro=true";
import { default as MessageSmsContentStepEXRkI0sucwIwi7X8078eJ9V1HIlHBuUqvvn2hKOkKjEMeta } from "/opt/build/repo/client/pages/messages/components/MessageSmsContentStep.vue?macro=true";
import { default as eventsZYPChD4wuqR0K5wF8pAVIyh7sLsXf5BV0KDIko9cfoYMeta } from "/opt/build/repo/client/pages/audience/[customer]/view/components/events.vue?macro=true";
import { default as CampaignSignUpSectionvgdAlkbMm63_45_qithurAbynIkB0OEapsB7nsJDJZkpEMeta } from "/opt/build/repo/client/pages/campaigns/components/CampaignSignUpSection.vue?macro=true";
import { default as MarketingPlannerTabm8_458rYsnvxjcQe7A86ZrtJv_ZuOllXaVl_45MXWPmsCt8Meta } from "/opt/build/repo/client/pages/events/components/view/MarketingPlannerTab.vue?macro=true";
import { default as DistributionCarduuImSF7SzskGbc_45AbmoVX8YsvK0RQznqcSyzlwlBvJIMeta } from "/opt/build/repo/client/pages/messages/[oid]/components/DistributionCard.vue?macro=true";
import { default as useDeliveryStats3b0DuCZmVkWMpIJzTalkfD2ydsrwS0FYlVRvWswRm20Meta } from "/opt/build/repo/client/pages/messages/[oid]/composables/useDeliveryStats.ts?macro=true";
import { default as utilsMessageClickStatsMaGEtZNezO7tux_HRObWkY2bRK5_yPO0J4nZPgZAAQoMeta } from "/opt/build/repo/client/pages/messages/[oid]/utils/utilsMessageClickStats.ts?macro=true";
import { default as utilsMessageNavigation_45NUunjc7BLbK_45un1cSfjKx_45pcVgme4N4dfOGsXZXhRYMeta } from "/opt/build/repo/client/pages/messages/[oid]/utils/utilsMessageNavigation.ts?macro=true";
import { default as MessagesConversionCellcSPD1im94jaT7VSiyQeFC4vOuF5f03gNU0ko8PMNmdkMeta } from "/opt/build/repo/client/pages/messages/components/MessagesConversionCell.vue?macro=true";
import { default as MessagesOverviewDraftsGL2XdqPDu2rfno_UdG4l77VczlGO_Dj1Xf3medw3O3AMeta } from "/opt/build/repo/client/pages/messages/components/MessagesOverviewDrafts.vue?macro=true";
import { default as useCreateMessageDrawerBpKO6Imzgt_45y3XEuU3WJSVl8t7TrmVyrs7x1IR7G8poMeta } from "/opt/build/repo/client/pages/messages/composables/useCreateMessageDrawer.ts?macro=true";
import { default as AudienceAdvancedFiltersq8i4Lz0NmJtYSAHHkXxTJovTER9zmjIljRatx9q5CGwMeta } from "/opt/build/repo/client/pages/audience/components/AudienceAdvancedFilters.vue?macro=true";
import { default as AudienceFilterConditionWP6bZyiK2sVyrBymWMkKBTXu43_uz2X5nfwqFUyD1pcMeta } from "/opt/build/repo/client/pages/audience/components/AudienceFilterCondition.vue?macro=true";
import { default as AudienceFilterGroupItemi4od27uNmOiob0v2fcHWKYJ0CkH_45Lv93I81g8uQbhfoMeta } from "/opt/build/repo/client/pages/audience/components/AudienceFilterGroupItem.vue?macro=true";
import { default as CampaignDetailsSectionnKn_qE74Nybwe5nZw8N4zHvNoByVc0z9X0S3FoBvC_0Meta } from "/opt/build/repo/client/pages/campaigns/components/CampaignDetailsSection.vue?macro=true";
import { default as SmsCountriesTablerXUEL6TG3YkIOv2sLDjqN1ILKVKc_451gaWEdaKYu5ULMMeta } from "/opt/build/repo/client/pages/messages/[oid]/components/SmsCountriesTable.vue?macro=true";
import { default as utilsRecipientStatusTagoXnRfmP82unv80b65JuJohykR8q_4550PaXLES_45B9wynsMeta } from "/opt/build/repo/client/pages/messages/[oid]/utils/utilsRecipientStatusTag.ts?macro=true";
import { default as EmailDesignPreviewModalZ55Q1Xrha8uQlTA8h7ue9H5GpRy7fDOLdc3I0HM57LoMeta } from "/opt/build/repo/client/pages/messages/components/EmailDesignPreviewModal.vue?macro=true";
import { default as MessageAdvancedSettings_WB9RF2nuyJePVp4cu11DHi_45_qqo801EGbVUJNk56gcMeta } from "/opt/build/repo/client/pages/messages/components/MessageAdvancedSettings.vue?macro=true";
import { default as MessageEmailContentStepnGI4rOD7c27Zi9z2aSDTPPim1brp9nxMSlB1S25pbM4Meta } from "/opt/build/repo/client/pages/messages/components/MessageEmailContentStep.vue?macro=true";
import { default as MessagesOverviewSectionWxE8f9i3TBsVbKO8IQgWLoDkce_xfn_45Sl4H_RHZnlZQMeta } from "/opt/build/repo/client/pages/messages/components/MessagesOverviewSection.vue?macro=true";
import { default as useMessageOverviewStatsNNj29tQVeA1_455_45_qxP3cTKcVTJQUXFlduQQmkjD27gMMeta } from "/opt/build/repo/client/pages/messages/composables/useMessageOverviewStats.ts?macro=true";
import { default as activityELvkj28oMODQ5hvO2HkQSOjdXPMGk3ufFLiJsDQwTKYMeta } from "/opt/build/repo/client/pages/audience/[customer]/view/components/activity.vue?macro=true";
import { default as overviewGQfEaE55nEhjZn1cTBe_FPbPQlxUSbCKjAO0jdTN2jIMeta } from "/opt/build/repo/client/pages/audience/[customer]/view/components/overview.vue?macro=true";
import { default as AddFanToMessageListModalbmlyCg4_c_2s5XAXndb7Mj2GzilouBsYbdqU_456TxdyQMeta } from "/opt/build/repo/client/pages/audience/components/AddFanToMessageListModal.vue?macro=true";
import { default as FilterConstraintSelectort6s9Wg25eonVWU3dKPGxQ4fyWUeXWMvhI5jjRuSj4j0Meta } from "/opt/build/repo/client/pages/audience/components/FilterConstraintSelector.vue?macro=true";
import { default as MessageOverviewTabT_45R1yG0JUnaFmjd_45OCc7HNowXWkT9d7X3UuvVh3i_SwMeta } from "/opt/build/repo/client/pages/messages/[oid]/components/MessageOverviewTab.vue?macro=true";
import { default as useConversionChart_R0ntn_45GtsFZJkcXD8YmR0tih5M3OWh305D87pQHp60Meta } from "/opt/build/repo/client/pages/messages/[oid]/composables/useConversionChart.ts?macro=true";
import { default as useSuppressedCountBP03WASWL17uZ4iSjualySBuMmNCdMHgHQuuNig9D_UMeta } from "/opt/build/repo/client/pages/messages/[oid]/composables/useSuppressedCount.ts?macro=true";
import { default as BeefreeDynamicTagsDialogLqrGPnEjHsR54Q_v6A6153fxLETHLwyIa5h2DX32iB0Meta } from "/opt/build/repo/client/pages/messages/components/BeefreeDynamicTagsDialog.vue?macro=true";
import { default as EmailTemplatePickerModaloC3cAuIXvOlhrU0I37N5c9GWebxOEJL20b4URTIETq8Meta } from "/opt/build/repo/client/pages/messages/components/EmailTemplatePickerModal.vue?macro=true";
import { default as ExportMessageReportModaldGiD3aqERXUJMrU_459YpQqXA29NRXdbJiowso3dcBNiUMeta } from "/opt/build/repo/client/pages/messages/components/ExportMessageReportModal.vue?macro=true";
import { default as purchasesUnYypFg1pR0_iAAfZGMKat3BbZvUnl17MzkAs2JN_452kMeta } from "/opt/build/repo/client/pages/audience/[customer]/view/components/purchases.vue?macro=true";
import { default as DeleteFilterModalledcSNS0qNuxU9Na7_oeQpfjGD5kwyHdxRPYC_45ezl9kMeta } from "/opt/build/repo/client/pages/audience/filters/components/DeleteFilterModal.vue?macro=true";
import { default as RenameFilterModalccYQ7ErwT53pO_8OFaGK_45mdoMKe_U_45lZjvfBEA3ns_4Meta } from "/opt/build/repo/client/pages/audience/filters/components/RenameFilterModal.vue?macro=true";
import { default as conditionSearchPickerResolution6To_4534kTRWLzva4Jhy4Q077U_45naWVn4ZBuq9z5txfsgMeta } from "/opt/build/repo/client/pages/audience/utils/conditionSearchPickerResolution.js?macro=true";
import { default as DeliverySummaryCardJEN8yM4v8VRPPWyuOEGBbg_sCQ_45gU9v9ghXsVuDnFj8Meta } from "/opt/build/repo/client/pages/messages/[oid]/components/DeliverySummaryCard.vue?macro=true";
import { default as CreateCampaignWidgetModalhuzEHQxYXoQf2CPIRPxsK36QQ30KkPH5HAKWZTa0jmcMeta } from "/opt/build/repo/client/pages/campaigns/components/CreateCampaignWidgetModal.vue?macro=true";
import { default as ConversionLinkSelectczAoQRXFunJTejmvxJPProy8H_7CUH_4Yb0oMlbqQgwMeta } from "/opt/build/repo/client/pages/messages/[oid]/components/ConversionLinkSelect.vue?macro=true";
import { default as MessageRecipientsTab1SDBt2BybofS0qSoF3gY6pmWlUU9J5bk1OWA4gwkyiMMeta } from "/opt/build/repo/client/pages/messages/[oid]/components/MessageRecipientsTab.vue?macro=true";
import { default as useMessageRecipientsdzP9dO43xVZlcoZhKKGTo_U0ctEssfMc4GJIAjdj148Meta } from "/opt/build/repo/client/pages/messages/[oid]/composables/useMessageRecipients.ts?macro=true";
import { default as useAccountMarketingCalendar_45HgDVz2eMXRXoVigJg6R_459digVqq0SpYeX5DTUqbhlEMeta } from "/opt/build/repo/client/pages/planner/composables/useAccountMarketingCalendar.ts?macro=true";
import { default as MessageConversionsTabP8Iv6cvVAcYngay3fxxZa_8BZv1HbUZFyq0uIJvEDnMMeta } from "/opt/build/repo/client/pages/messages/[oid]/components/MessageConversionsTab.vue?macro=true";
import { default as useMessageConversionsdvlraHx7OTE1bx00ekJLZWt_45V8lUfLsPrkO43Oc_45dMkMeta } from "/opt/build/repo/client/pages/messages/[oid]/composables/useMessageConversions.ts?macro=true";
import { default as data_45capturewjyIKsWPvsbzN3WjJYkRIuZ0bdVWPf1JXZoeY49OHBgMeta } from "/opt/build/repo/client/pages/audience/[customer]/view/components/data-capture.vue?macro=true";
import { default as ImportContactsOneschemaModal_qQBZuewhGkd2LOinq5VX3J3_45dofGKEvtRFs3CebEC0Meta } from "/opt/build/repo/client/pages/audience/components/ImportContactsOneschemaModal.vue?macro=true";
import { default as useAdvancedFiltersWithGroupsr90IODgRoipXcl3bfp1iVCjTNuisXigWLkkFdE8tInYMeta } from "/opt/build/repo/client/pages/audience/composables/useAdvancedFiltersWithGroups.js?macro=true";
import { default as CampaignConfirmationSectionCxGwXpVu71HGX_45B0AHEfKAjmTnIFCEr_45lZsLsDT4HaAMeta } from "/opt/build/repo/client/pages/campaigns/components/CampaignConfirmationSection.vue?macro=true";
import { default as CampaignGamificationSectiondGR2dpEZgCGba5ay1SqmyXZZdbqu6BavhjsqM01LwWMMeta } from "/opt/build/repo/client/pages/campaigns/components/CampaignGamificationSection.vue?macro=true";
import { default as useAdvancedSettingsSnapshotO8iZJQyhBnPHE0Fo9JWxsJO_Z4H_JUAGW_8awwUmN7YMeta } from "/opt/build/repo/client/pages/campaigns/composables/useAdvancedSettingsSnapshot.ts?macro=true";
import { default as usePopulateGamificationData5QDyaRNkTjkL4GC_KAxgV7UrezLMfldaxdGIKCo7tloMeta } from "/opt/build/repo/client/pages/campaigns/composables/usePopulateGamificationData.ts?macro=true";
import { default as MessageLinkActivityTabclrAil2AVEv08UZfQneGX0EEL71lXKbwxEitYNzmzc4Meta } from "/opt/build/repo/client/pages/messages/[oid]/components/MessageLinkActivityTab.vue?macro=true";
import { default as MessagingCardh9yjBdj7ZG8VcEOHIU5QfIdoH88QnUwK8QYepCZMO34Meta } from "/opt/build/repo/client/pages/audience/[customer]/view/components/MessagingCard.vue?macro=true";
import { default as validateInviteFormpUEMXpLEIb3VKWc4NnpaIuzAU2okLFhEQfF7ZvJ5kU4Meta } from "/opt/build/repo/client/pages/authenticate/invite/composables/validateInviteForm.ts?macro=true";
import { default as MessageDeliverabilityTabUkcYjwcew2MP5kMbFg27XrQT2lnys0DVvnTKQLPUuloMeta } from "/opt/build/repo/client/pages/messages/[oid]/components/MessageDeliverabilityTab.vue?macro=true";
import { default as customerProfileDataCaptureDVvxVulzAbbYg5uA0NOtM45J2XNLGqwcUCqTlbhlMhUMeta } from "/opt/build/repo/client/pages/audience/[customer]/view/customerProfileDataCapture.vue?macro=true";
import { default as OrderDetailsModalqmAcHeh_ZbnRVAc1MJFJ2Oz1N_DIIs9rEKn3xZVhzrwMeta } from "/opt/build/repo/client/pages/audience/[customer]/view/components/OrderDetailsModal.vue?macro=true";
import { default as SelectDateRangeModal2zfz2MhnS6TepTIvASOXDnc9syyv69gy2BtTJ7g_45kY0Meta } from "/opt/build/repo/client/pages/audience/[customer]/view/components/SelectDateRangeModal.vue?macro=true";
import { default as EventTicketSalesCharty4eOcVBO66OJfBHgdT285B1eAtt_45MMzVsXcnKajMpCkMeta } from "/opt/build/repo/client/pages/events/components/view/ticket-sales/EventTicketSalesChart.vue?macro=true";
import { default as EventTicketTypesChartWHs_45mmX7_2Sf9LIbuIc9fUYjoWT21LquF4B5feECN6wMeta } from "/opt/build/repo/client/pages/events/components/view/ticket-sales/EventTicketTypesChart.vue?macro=true";
import { default as EventTicketSalesOverviewCtS822_45OHcYfVos7SGmH4O_Bg7pKzcNDkKdlWcy8LEkMeta } from "/opt/build/repo/client/pages/events/components/view/ticket-sales/EventTicketSalesOverview.vue?macro=true";
import { default as EventTicketSalesAttribution56ldSW9IYsKXKuQXw1oLEdxkfFYfRcdxZSIp3RiHh4EMeta } from "/opt/build/repo/client/pages/events/components/view/ticket-sales/EventTicketSalesAttribution.vue?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "/pages",
    path: "/",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/index.vue")
  },
  {
    name: "/pages/[...all]",
    path: "/:all(.*)*",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/[...all].vue")
  },
  {
    name: "/pages/events",
    path: "/events",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/index.vue")
  },
  {
    name: "/pages/events/create",
    path: "/events/create",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/create.vue")
  },
  {
    name: "/pages/planner",
    path: "/planner",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/planner/index.vue")
  },
  {
    name: "/pages/audience",
    path: "/audience",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/index.vue")
  },
  {
    name: "/pages/messages",
    path: "/messages",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/index.vue")
  },
  {
    name: "/pages/campaigns",
    path: "/campaigns",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/index.vue")
  },
  {
    name: "/pages/messages/create",
    path: "/messages/create",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/create.vue")
  },
  {
    name: "/pages/campaigns/create",
    path: "/campaigns/create",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/create.vue")
  },
  {
    name: "/pages/events/past",
    path: "/events/past",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/past/index.vue")
  },
  {
    name: "/pages/authenticate/login",
    path: "/authenticate/login",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/authenticate/login.vue")
  },
  {
    name: "/pages/audience/tags",
    path: "/audience/tags",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/tags/index.vue")
  },
  {
    name: "/pages/authenticate/signup",
    path: "/authenticate/signup",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/authenticate/signup.vue")
  },
  {
    name: "/pages/messages/[oid]/view",
    path: "/messages/:oid()/view",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/view.vue")
  },
  {
    name: "/pages/campaigns/view/[oid]",
    path: "/campaigns/view/:oid()",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/view/[oid].vue")
  },
  {
    name: "/pages/custom-planner",
    path: "/custom-planner",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/custom-planner/index.vue")
  },
  {
    name: "/pages/messages/lists",
    path: "/messages/lists",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/lists/index.vue")
  },
  {
    name: "/pages/events/archived",
    path: "/events/archived",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/archived/index.vue")
  },
  {
    name: "/pages/audience/filters",
    path: "/audience/filters",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/filters/index.vue")
  },
  {
    name: "/pages/campaigns/update/[oid]",
    path: "/campaigns/update/:oid()",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/update/[oid].vue")
  },
  {
    name: "/pages/campaigns/view/signups",
    path: "/campaigns/view/signups",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/view/signups.vue")
  },
  {
    name: "/pages/events/[eventoid]/edit",
    path: "/events/:eventoid()/edit",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/[eventoid]/edit.vue")
  },
  {
    name: "/pages/campaigns/email-example",
    path: "/campaigns/email-example",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/email-example.vue")
  },
  {
    name: "/pages/campaigns/view/insights",
    path: "/campaigns/view/insights",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/view/insights.vue")
  },
  {
    name: "/pages/events/composables/inde",
    path: "/events/composables",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/composables/index.ts")
  },
  {
    name: "/pages/campaigns/view/dashboard",
    path: "/campaigns/view/dashboard",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/view/dashboard.vue")
  },
  {
    name: "/pages/messages/templates",
    path: "/messages/templates",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/templates/index.vue")
  },
  {
    name: "/pages/authenticate/email-verify",
    path: "/authenticate/email-verify",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/authenticate/email-verify.vue")
  },
  {
    name: "/pages/authenticate/invite",
    path: "/authenticate/invite",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/authenticate/invite/index.vue")
  },
  {
    name: "/pages/events/types/calendarItem",
    path: "/events/types/calendarItems",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/types/calendarItems.ts")
  },
  {
    name: "/pages/audience/utils/criteriaMen",
    path: "/audience/utils/criteriaMenu",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/utils/criteriaMenu.js")
  },
  {
    name: "/pages/audience/utils/filterNamin",
    path: "/audience/utils/filterNaming",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/utils/filterNaming.ts")
  },
  {
    name: "/pages/authenticate/ResetPassword",
    path: "/authenticate/ResetPassword",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/authenticate/ResetPassword.vue")
  },
  {
    name: "/pages/authenticate/billing-details",
    path: "/authenticate/billing-details",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/authenticate/billing-details.vue")
  },
  {
    name: "/pages/authenticate/forgot-password",
    path: "/authenticate/forgot-password",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/authenticate/forgot-password.vue")
  },
  {
    name: "/pages/campaigns/view/registrations",
    path: "/campaigns/view/registrations",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/view/registrations.vue")
  },
  {
    name: "/pages/events/[eventoid]/view/event",
    path: "/events/:eventoid()/view/event",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/[eventoid]/view/event.vue")
  },
  {
    name: "/pages/events/[eventoid]/view/group",
    path: "/events/:eventoid()/view/group",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/[eventoid]/view/group.vue")
  },
  {
    name: "/pages/audience/data-capture-example",
    path: "/audience/data-capture-example",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/data-capture-example.vue")
  },
  {
    name: "/pages/audience/[customer]/view",
    path: "/audience/:customer()/view",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/index.vue")
  },
  {
    name: "/pages/audience/components/FilterTabs",
    path: "/audience/components/FilterTabs",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/FilterTabs.vue")
  },
  {
    name: "/pages/authenticate/import-sales-data",
    path: "/authenticate/import-sales-data",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/authenticate/import-sales-data.vue")
  },
  {
    name: "/pages/authenticate/invite-sent",
    path: "/authenticate/invite-sent",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/authenticate/invite-sent/index.vue")
  },
  {
    name: "/pages/messages/composables/useSmsCos",
    path: "/messages/composables/useSmsCost",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useSmsCost.ts")
  },
  {
    name: "/pages/messages/composables/useMessage",
    path: "/messages/composables/useMessages",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useMessages.ts")
  },
  {
    name: "/pages/messages/composables/useSendTim",
    path: "/messages/composables/useSendTime",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useSendTime.ts")
  },
  {
    name: "/pages/messages/utils/utilsMessageList",
    path: "/messages/utils/utilsMessageLists",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/utils/utilsMessageLists.ts")
  },
  {
    name: "/pages/events/components/EditEventGroup",
    path: "/events/components/EditEventGroup",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/EditEventGroup.vue")
  },
  {
    name: "/pages/events/components/view/OrdersTab",
    path: "/events/components/view/OrdersTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/view/OrdersTab.vue")
  },
  {
    name: "/pages/messages/components/MessagesList",
    path: "/messages/components/MessagesList",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessagesList.vue")
  },
  {
    name: "/pages/messages/composables/messageName",
    path: "/messages/composables/messageNames",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/messageNames.ts")
  },
  {
    name: "/pages/audience/components/FilterTagList",
    path: "/audience/components/FilterTagList",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/FilterTagList.vue")
  },
  {
    name: "/pages/audience/utils/conditionCompletio",
    path: "/audience/utils/conditionCompletion",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/utils/conditionCompletion.ts")
  },
  {
    name: "/pages/authenticate/invite-expired",
    path: "/authenticate/invite-expired",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/authenticate/invite-expired/index.vue")
  },
  {
    name: "/pages/audience/[customer]/view/campaigns",
    path: "/audience/:customer()/view/campaigns",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/campaigns.vue")
  },
  {
    name: "/pages/audience/components/FavoriteButton",
    path: "/audience/components/FavoriteButton",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/FavoriteButton.vue")
  },
  {
    name: "/pages/audience/components/FilterListItem",
    path: "/audience/components/FilterListItem",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/FilterListItem.vue")
  },
  {
    name: "/pages/audience/composables/useTagCreatio",
    path: "/audience/composables/useTagCreation",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/composables/useTagCreation.js")
  },
  {
    name: "/pages/events/components/GroupEventsModal",
    path: "/events/components/GroupEventsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/GroupEventsModal.vue")
  },
  {
    name: "/pages/events/components/view/InsightsTab",
    path: "/events/components/view/InsightsTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/view/InsightsTab.vue")
  },
  {
    name: "/pages/events/components/view/MessagesTab",
    path: "/events/components/view/MessagesTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/view/MessagesTab.vue")
  },
  {
    name: "/pages/events/composables/useEventMessage",
    path: "/events/composables/useEventMessages",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/composables/useEventMessages.ts")
  },
  {
    name: "/pages/messages/components/MessageSmsCost",
    path: "/messages/components/MessageSmsCost",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessageSmsCost.vue")
  },
  {
    name: "/pages/messages/composables/messageAction",
    path: "/messages/composables/messageActions",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/messageActions.ts")
  },
  {
    name: "/pages/messages/composables/messageResult",
    path: "/messages/composables/messageResults",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/messageResults.ts")
  },
  {
    name: "/pages/messages/composables/useEmailDesig",
    path: "/messages/composables/useEmailDesign",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useEmailDesign.ts")
  },
  {
    name: "/pages/messages/composables/useLinkedEven",
    path: "/messages/composables/useLinkedEvent",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useLinkedEvent.ts")
  },
  {
    name: "/pages/audience/components/AudienceFilters",
    path: "/audience/components/AudienceFilters",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/AudienceFilters.vue")
  },
  {
    name: "/pages/campaigns/components/AddActionModal",
    path: "/campaigns/components/AddActionModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/AddActionModal.vue")
  },
  {
    name: "/pages/campaigns/components/AddRewardModal",
    path: "/campaigns/components/AddRewardModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/AddRewardModal.vue")
  },
  {
    name: "/pages/campaigns/components/EditFieldModal",
    path: "/campaigns/components/EditFieldModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/EditFieldModal.vue")
  },
  {
    name: "/pages/events/components/DeleteEventsModal",
    path: "/events/components/DeleteEventsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/DeleteEventsModal.vue")
  },
  {
    name: "/pages/events/components/ImportEventsModal",
    path: "/events/components/ImportEventsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/ImportEventsModal.vue")
  },
  {
    name: "/pages/events/composables/useEventCampaign",
    path: "/events/composables/useEventCampaigns",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/composables/useEventCampaigns.ts")
  },
  {
    name: "/pages/messages/components/ImportHtmlModal",
    path: "/messages/components/ImportHtmlModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/ImportHtmlModal.vue")
  },
  {
    name: "/pages/messages/components/MessagesToolbar",
    path: "/messages/components/MessagesToolbar",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessagesToolbar.vue")
  },
  {
    name: "/pages/messages/composables/draftCompletio",
    path: "/messages/composables/draftCompletion",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/draftCompletion.ts")
  },
  {
    name: "/pages/planner/components/PlannerDayDrawer",
    path: "/planner/components/PlannerDayDrawer",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/planner/components/PlannerDayDrawer.vue")
  },
  {
    name: "/pages/audience/components/ContactFormModal",
    path: "/audience/components/ContactFormModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/ContactFormModal.vue")
  },
  {
    name: "/pages/audience/components/EditFanTagsModal",
    path: "/audience/components/EditFanTagsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/EditFanTagsModal.vue")
  },
  {
    name: "/pages/audience/components/FanMassEditModal",
    path: "/audience/components/FanMassEditModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/FanMassEditModal.vue")
  },
  {
    name: "/pages/audience/composables/useActiveFilter",
    path: "/audience/composables/useActiveFilters",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/composables/useActiveFilters.js")
  },
  {
    name: "/pages/authenticate/components/connect-card",
    path: "/authenticate/components/connect-card",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/authenticate/components/connect-card.vue")
  },
  {
    name: "/pages/campaigns/components/EditActionModal",
    path: "/campaigns/components/EditActionModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/EditActionModal.vue")
  },
  {
    name: "/pages/campaigns/components/EditButtonModal",
    path: "/campaigns/components/EditButtonModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/EditButtonModal.vue")
  },
  {
    name: "/pages/campaigns/composables/useGamificatio",
    path: "/campaigns/composables/useGamification",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/composables/useGamification.js")
  },
  {
    name: "/pages/events/components/ArchiveEventsModal",
    path: "/events/components/ArchiveEventsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/ArchiveEventsModal.vue")
  },
  {
    name: "/pages/messages/components/MessagesOverview",
    path: "/messages/components/MessagesOverview",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessagesOverview.vue")
  },
  {
    name: "/pages/messages/components/MessagesStatsBar",
    path: "/messages/components/MessagesStatsBar",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessagesStatsBar.vue")
  },
  {
    name: "/pages/messages/composables/useBeefreeEdito",
    path: "/messages/composables/useBeefreeEditor",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useBeefreeEditor.ts")
  },
  {
    name: "/pages/messages/composables/useSenderDetail",
    path: "/messages/composables/useSenderDetails",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useSenderDetails.ts")
  },
  {
    name: "/pages/audience/[customer]/view/posPurchases",
    path: "/audience/:customer()/view/posPurchases",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/posPurchases.vue")
  },
  {
    name: "/pages/audience/composables/useContactColumn",
    path: "/audience/composables/useContactColumns",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/composables/useContactColumns.ts")
  },
  {
    name: "/pages/campaigns/components/AdvancedSettings",
    path: "/campaigns/components/AdvancedSettings",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/AdvancedSettings.vue")
  },
  {
    name: "/pages/campaigns/composables/useCampaignLogi",
    path: "/campaigns/composables/useCampaignLogic",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/composables/useCampaignLogic.js")
  },
  {
    name: "/pages/events/components/view/DataCaptureTab",
    path: "/events/components/view/DataCaptureTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/view/DataCaptureTab.vue")
  },
  {
    name: "/pages/events/components/view/TicketSalesTab",
    path: "/events/components/view/TicketSalesTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/view/TicketSalesTab.vue")
  },
  {
    name: "/pages/messages/[oid]/utils/utilsDistributio",
    path: "/messages/:oid()/utils/utilsDistribution",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/utils/utilsDistribution.ts")
  },
  {
    name: "/pages/messages/[oid]/utils/utilsMessageStat",
    path: "/messages/:oid()/utils/utilsMessageStats",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/utils/utilsMessageStats.ts")
  },
  {
    name: "/pages/messages/[oid]/utils/utilsSmsCountrie",
    path: "/messages/:oid()/utils/utilsSmsCountries",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/utils/utilsSmsCountries.ts")
  },
  {
    name: "/pages/messages/components/MessageSmsPreview",
    path: "/messages/components/MessageSmsPreview",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessageSmsPreview.vue")
  },
  {
    name: "/pages/messages/components/SaveTemplateModal",
    path: "/messages/components/SaveTemplateModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/SaveTemplateModal.vue")
  },
  {
    name: "/pages/messages/composables/messageStatusInf",
    path: "/messages/composables/messageStatusInfo",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/messageStatusInfo.ts")
  },
  {
    name: "/pages/audience/components/FanMassDeleteModal",
    path: "/audience/components/FanMassDeleteModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/FanMassDeleteModal.vue")
  },
  {
    name: "/pages/audience/composables/useAdvancedFilter",
    path: "/audience/composables/useAdvancedFilters",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/composables/useAdvancedFilters.js")
  },
  {
    name: "/pages/audience/composables/useResourceOption",
    path: "/audience/composables/useResourceOptions",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/composables/useResourceOptions.js")
  },
  {
    name: "/pages/campaigns/components/EditCheckboxModal",
    path: "/campaigns/components/EditCheckboxModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/EditCheckboxModal.vue")
  },
  {
    name: "/pages/campaigns/components/GamificationStats",
    path: "/campaigns/components/GamificationStats",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/GamificationStats.vue")
  },
  {
    name: "/pages/campaigns/components/RedirectDelayCard",
    path: "/campaigns/components/RedirectDelayCard",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/RedirectDelayCard.vue")
  },
  {
    name: "/pages/events/components/DuplicateEventsModal",
    path: "/events/components/DuplicateEventsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/DuplicateEventsModal.vue")
  },
  {
    name: "/pages/events/composables/useEventDataCapture",
    path: "/events/composables/useEventDataCaptures",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/composables/useEventDataCaptures.ts")
  },
  {
    name: "/pages/events/composables/useMarketingCalenda",
    path: "/events/composables/useMarketingCalendar",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/composables/useMarketingCalendar.ts")
  },
  {
    name: "/pages/messages/[oid]/components/TopLinksCard",
    path: "/messages/:oid()/components/TopLinksCard",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/components/TopLinksCard.vue")
  },
  {
    name: "/pages/messages/[oid]/composables/useShortUrl",
    path: "/messages/:oid()/composables/useShortUrls",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/composables/useShortUrls.ts")
  },
  {
    name: "/pages/messages/components/BeefreeEmailEditor",
    path: "/messages/components/BeefreeEmailEditor",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/BeefreeEmailEditor.vue")
  },
  {
    name: "/pages/messages/components/BeefreeEventDialog",
    path: "/messages/components/BeefreeEventDialog",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/BeefreeEventDialog.vue")
  },
  {
    name: "/pages/messages/components/MessageLinkedEvent",
    path: "/messages/components/MessageLinkedEvent",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessageLinkedEvent.vue")
  },
  {
    name: "/pages/messages/composables/useExportDateRang",
    path: "/messages/composables/useExportDateRange",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useExportDateRange.ts")
  },
  {
    name: "/pages/messages/composables/useMessagesFilter",
    path: "/messages/composables/useMessagesFilters",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useMessagesFilters.ts")
  },
  {
    name: "/pages/messages/composables/useMessagesLookup",
    path: "/messages/composables/useMessagesLookups",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useMessagesLookups.ts")
  },
  {
    name: "/pages/audience/components/AudienceFilterGroup",
    path: "/audience/components/AudienceFilterGroup",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/AudienceFilterGroup.vue")
  },
  {
    name: "/pages/audience/composables/useResourceFetcher",
    path: "/audience/composables/useResourceFetchers",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/composables/useResourceFetchers.js")
  },
  {
    name: "/pages/audience/tags/components/GroupTagsModal",
    path: "/audience/tags/components/GroupTagsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/tags/components/GroupTagsModal.vue")
  },
  {
    name: "/pages/audience/tags/components/MergeTagsModal",
    path: "/audience/tags/components/MergeTagsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/tags/components/MergeTagsModal.vue")
  },
  {
    name: "/pages/campaigns/components/DesktopLayoutModal",
    path: "/campaigns/components/DesktopLayoutModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/DesktopLayoutModal.vue")
  },
  {
    name: "/pages/campaigns/components/InviteFriendsModal",
    path: "/campaigns/components/InviteFriendsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/InviteFriendsModal.vue")
  },
  {
    name: "/pages/campaigns/composables/useCampaignAction",
    path: "/campaigns/composables/useCampaignActions",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/composables/useCampaignActions.ts")
  },
  {
    name: "/pages/events/composables/useEventCustomEntrie",
    path: "/events/composables/useEventCustomEntries",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/composables/useEventCustomEntries.ts")
  },
  {
    name: "/pages/messages/components/CreateMessageDrawer",
    path: "/messages/components/CreateMessageDrawer",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/CreateMessageDrawer.vue")
  },
  {
    name: "/pages/messages/components/MessageEmailBuilder",
    path: "/messages/components/MessageEmailBuilder",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessageEmailBuilder.vue")
  },
  {
    name: "/pages/messages/components/MessageEmailPreview",
    path: "/messages/components/MessageEmailPreview",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessageEmailPreview.vue")
  },
  {
    name: "/pages/messages/components/MessageSendTimeStep",
    path: "/messages/components/MessageSendTimeStep",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessageSendTimeStep.vue")
  },
  {
    name: "/pages/audience/[customer]/view/ticketPurchases",
    path: "/audience/:customer()/view/ticketPurchases",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/ticketPurchases.vue")
  },
  {
    name: "/pages/audience/composables/useFilterCompressio",
    path: "/audience/composables/useFilterCompression",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/composables/useFilterCompression.ts")
  },
  {
    name: "/pages/audience/tags/components/DeleteTagsModal",
    path: "/audience/tags/components/DeleteTagsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/tags/components/DeleteTagsModal.vue")
  },
  {
    name: "/pages/audience/tags/components/RenameTagsModal",
    path: "/audience/tags/components/RenameTagsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/tags/components/RenameTagsModal.vue")
  },
  {
    name: "/pages/campaigns/components/AddCustomFieldModal",
    path: "/campaigns/components/AddCustomFieldModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/AddCustomFieldModal.vue")
  },
  {
    name: "/pages/campaigns/components/DeleteCampaignModal",
    path: "/campaigns/components/DeleteCampaignModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/DeleteCampaignModal.vue")
  },
  {
    name: "/pages/events/components/ClearTicketOrdersModal",
    path: "/events/components/ClearTicketOrdersModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/ClearTicketOrdersModal.vue")
  },
  {
    name: "/pages/messages/[oid]/composables/useMessageVie",
    path: "/messages/:oid()/composables/useMessageView",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/composables/useMessageView.ts")
  },
  {
    name: "/pages/messages/[oid]/utils/utilsConversionStat",
    path: "/messages/:oid()/utils/utilsConversionStats",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/utils/utilsConversionStats.ts")
  },
  {
    name: "/pages/messages/components/MessagesConfirmModal",
    path: "/messages/components/MessagesConfirmModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessagesConfirmModal.vue")
  },
  {
    name: "/pages/messages/composables/messagesFeatureFlag",
    path: "/messages/composables/messagesFeatureFlags",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/messagesFeatureFlags.ts")
  },
  {
    name: "/pages/messages/composables/useMessageEditDrawe",
    path: "/messages/composables/useMessageEditDrawer",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useMessageEditDrawer.ts")
  },
  {
    name: "/pages/audience/components/FilterConstraintInput",
    path: "/audience/components/FilterConstraintInput",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/FilterConstraintInput.vue")
  },
  {
    name: "/pages/campaigns/components/CampaignPreviewFrame",
    path: "/campaigns/components/CampaignPreviewFrame",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/CampaignPreviewFrame.vue")
  },
  {
    name: "/pages/campaigns/components/CampaignTypeSelector",
    path: "/campaigns/components/CampaignTypeSelector",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/CampaignTypeSelector.vue")
  },
  {
    name: "/pages/events/components/ImportTicketOrdersModal",
    path: "/events/components/ImportTicketOrdersModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/ImportTicketOrdersModal.vue")
  },
  {
    name: "/pages/messages/[oid]/components/ConversionChart",
    path: "/messages/:oid()/components/ConversionChart",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/components/ConversionChart.vue")
  },
  {
    name: "/pages/messages/[oid]/components/ConversionTable",
    path: "/messages/:oid()/components/ConversionTable",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/components/ConversionTable.vue")
  },
  {
    name: "/pages/messages/[oid]/composables/useMessageStat",
    path: "/messages/:oid()/composables/useMessageStats",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/composables/useMessageStats.ts")
  },
  {
    name: "/pages/messages/[oid]/utils/utilsRecipientsViewB",
    path: "/messages/:oid()/utils/utilsRecipientsViewBy",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/utils/utilsRecipientsViewBy.ts")
  },
  {
    name: "/pages/messages/components/MessageSmsContentStep",
    path: "/messages/components/MessageSmsContentStep",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessageSmsContentStep.vue")
  },
  {
    name: "/pages/audience/[customer]/view/components/events",
    path: "/audience/:customer()/view/components/events",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/components/events.vue")
  },
  {
    name: "/pages/campaigns/components/CampaignSignUpSection",
    path: "/campaigns/components/CampaignSignUpSection",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/CampaignSignUpSection.vue")
  },
  {
    name: "/pages/events/components/view/MarketingPlannerTab",
    path: "/events/components/view/MarketingPlannerTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/view/MarketingPlannerTab.vue")
  },
  {
    name: "/pages/messages/[oid]/components/DistributionCard",
    path: "/messages/:oid()/components/DistributionCard",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/components/DistributionCard.vue")
  },
  {
    name: "/pages/messages/[oid]/composables/useDeliveryStat",
    path: "/messages/:oid()/composables/useDeliveryStats",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/composables/useDeliveryStats.ts")
  },
  {
    name: "/pages/messages/[oid]/utils/utilsMessageClickStat",
    path: "/messages/:oid()/utils/utilsMessageClickStats",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/utils/utilsMessageClickStats.ts")
  },
  {
    name: "/pages/messages/[oid]/utils/utilsMessageNavigatio",
    path: "/messages/:oid()/utils/utilsMessageNavigation",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/utils/utilsMessageNavigation.ts")
  },
  {
    name: "/pages/messages/components/MessagesConversionCell",
    path: "/messages/components/MessagesConversionCell",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessagesConversionCell.vue")
  },
  {
    name: "/pages/messages/components/MessagesOverviewDrafts",
    path: "/messages/components/MessagesOverviewDrafts",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessagesOverviewDrafts.vue")
  },
  {
    name: "/pages/messages/composables/useCreateMessageDrawe",
    path: "/messages/composables/useCreateMessageDrawer",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useCreateMessageDrawer.ts")
  },
  {
    name: "/pages/audience/components/AudienceAdvancedFilters",
    path: "/audience/components/AudienceAdvancedFilters",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/AudienceAdvancedFilters.vue")
  },
  {
    name: "/pages/audience/components/AudienceFilterCondition",
    path: "/audience/components/AudienceFilterCondition",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/AudienceFilterCondition.vue")
  },
  {
    name: "/pages/audience/components/AudienceFilterGroupItem",
    path: "/audience/components/AudienceFilterGroupItem",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/AudienceFilterGroupItem.vue")
  },
  {
    name: "/pages/campaigns/components/CampaignDetailsSection",
    path: "/campaigns/components/CampaignDetailsSection",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/CampaignDetailsSection.vue")
  },
  {
    name: "/pages/messages/[oid]/components/SmsCountriesTable",
    path: "/messages/:oid()/components/SmsCountriesTable",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/components/SmsCountriesTable.vue")
  },
  {
    name: "/pages/messages/[oid]/utils/utilsRecipientStatusTa",
    path: "/messages/:oid()/utils/utilsRecipientStatusTag",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/utils/utilsRecipientStatusTag.ts")
  },
  {
    name: "/pages/messages/components/EmailDesignPreviewModal",
    path: "/messages/components/EmailDesignPreviewModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/EmailDesignPreviewModal.vue")
  },
  {
    name: "/pages/messages/components/MessageAdvancedSettings",
    path: "/messages/components/MessageAdvancedSettings",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessageAdvancedSettings.vue")
  },
  {
    name: "/pages/messages/components/MessageEmailContentStep",
    path: "/messages/components/MessageEmailContentStep",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessageEmailContentStep.vue")
  },
  {
    name: "/pages/messages/components/MessagesOverviewSection",
    path: "/messages/components/MessagesOverviewSection",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/MessagesOverviewSection.vue")
  },
  {
    name: "/pages/messages/composables/useMessageOverviewStat",
    path: "/messages/composables/useMessageOverviewStats",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/composables/useMessageOverviewStats.ts")
  },
  {
    name: "/pages/audience/[customer]/view/components/activity",
    path: "/audience/:customer()/view/components/activity",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/components/activity.vue")
  },
  {
    name: "/pages/audience/[customer]/view/components/overview",
    path: "/audience/:customer()/view/components/overview",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/components/overview.vue")
  },
  {
    name: "/pages/audience/components/AddFanToMessageListModal",
    path: "/audience/components/AddFanToMessageListModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/AddFanToMessageListModal.vue")
  },
  {
    name: "/pages/audience/components/FilterConstraintSelector",
    path: "/audience/components/FilterConstraintSelector",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/FilterConstraintSelector.vue")
  },
  {
    name: "/pages/messages/[oid]/components/MessageOverviewTab",
    path: "/messages/:oid()/components/MessageOverviewTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/components/MessageOverviewTab.vue")
  },
  {
    name: "/pages/messages/[oid]/composables/useConversionChar",
    path: "/messages/:oid()/composables/useConversionChart",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/composables/useConversionChart.ts")
  },
  {
    name: "/pages/messages/[oid]/composables/useSuppressedCoun",
    path: "/messages/:oid()/composables/useSuppressedCount",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/composables/useSuppressedCount.ts")
  },
  {
    name: "/pages/messages/components/BeefreeDynamicTagsDialog",
    path: "/messages/components/BeefreeDynamicTagsDialog",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/BeefreeDynamicTagsDialog.vue")
  },
  {
    name: "/pages/messages/components/EmailTemplatePickerModal",
    path: "/messages/components/EmailTemplatePickerModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/EmailTemplatePickerModal.vue")
  },
  {
    name: "/pages/messages/components/ExportMessageReportModal",
    path: "/messages/components/ExportMessageReportModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/components/ExportMessageReportModal.vue")
  },
  {
    name: "/pages/audience/[customer]/view/components/purchases",
    path: "/audience/:customer()/view/components/purchases",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/components/purchases.vue")
  },
  {
    name: "/pages/audience/filters/components/DeleteFilterModal",
    path: "/audience/filters/components/DeleteFilterModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/filters/components/DeleteFilterModal.vue")
  },
  {
    name: "/pages/audience/filters/components/RenameFilterModal",
    path: "/audience/filters/components/RenameFilterModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/filters/components/RenameFilterModal.vue")
  },
  {
    name: "/pages/audience/utils/conditionSearchPickerResolutio",
    path: "/audience/utils/conditionSearchPickerResolution",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/utils/conditionSearchPickerResolution.js")
  },
  {
    name: "/pages/messages/[oid]/components/DeliverySummaryCard",
    path: "/messages/:oid()/components/DeliverySummaryCard",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/components/DeliverySummaryCard.vue")
  },
  {
    name: "/pages/campaigns/components/CreateCampaignWidgetModal",
    path: "/campaigns/components/CreateCampaignWidgetModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/CreateCampaignWidgetModal.vue")
  },
  {
    name: "/pages/messages/[oid]/components/ConversionLinkSelect",
    path: "/messages/:oid()/components/ConversionLinkSelect",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/components/ConversionLinkSelect.vue")
  },
  {
    name: "/pages/messages/[oid]/components/MessageRecipientsTab",
    path: "/messages/:oid()/components/MessageRecipientsTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/components/MessageRecipientsTab.vue")
  },
  {
    name: "/pages/messages/[oid]/composables/useMessageRecipient",
    path: "/messages/:oid()/composables/useMessageRecipients",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/composables/useMessageRecipients.ts")
  },
  {
    name: "/pages/planner/composables/useAccountMarketingCalenda",
    path: "/planner/composables/useAccountMarketingCalendar",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/planner/composables/useAccountMarketingCalendar.ts")
  },
  {
    name: "/pages/messages/[oid]/components/MessageConversionsTab",
    path: "/messages/:oid()/components/MessageConversionsTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/components/MessageConversionsTab.vue")
  },
  {
    name: "/pages/messages/[oid]/composables/useMessageConversion",
    path: "/messages/:oid()/composables/useMessageConversions",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/composables/useMessageConversions.ts")
  },
  {
    name: "/pages/audience/[customer]/view/components/data-capture",
    path: "/audience/:customer()/view/components/data-capture",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/components/data-capture.vue")
  },
  {
    name: "/pages/audience/components/ImportContactsOneschemaModal",
    path: "/audience/components/ImportContactsOneschemaModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/components/ImportContactsOneschemaModal.vue")
  },
  {
    name: "/pages/audience/composables/useAdvancedFiltersWithGroup",
    path: "/audience/composables/useAdvancedFiltersWithGroups",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/composables/useAdvancedFiltersWithGroups.js")
  },
  {
    name: "/pages/campaigns/components/CampaignConfirmationSection",
    path: "/campaigns/components/CampaignConfirmationSection",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/CampaignConfirmationSection.vue")
  },
  {
    name: "/pages/campaigns/components/CampaignGamificationSection",
    path: "/campaigns/components/CampaignGamificationSection",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/components/CampaignGamificationSection.vue")
  },
  {
    name: "/pages/campaigns/composables/useAdvancedSettingsSnapsho",
    path: "/campaigns/composables/useAdvancedSettingsSnapshot",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/composables/useAdvancedSettingsSnapshot.ts")
  },
  {
    name: "/pages/campaigns/composables/usePopulateGamificationDat",
    path: "/campaigns/composables/usePopulateGamificationData",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/campaigns/composables/usePopulateGamificationData.ts")
  },
  {
    name: "/pages/messages/[oid]/components/MessageLinkActivityTab",
    path: "/messages/:oid()/components/MessageLinkActivityTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/components/MessageLinkActivityTab.vue")
  },
  {
    name: "/pages/audience/[customer]/view/components/MessagingCard",
    path: "/audience/:customer()/view/components/MessagingCard",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/components/MessagingCard.vue")
  },
  {
    name: "/pages/authenticate/invite/composables/validateInviteFor",
    path: "/authenticate/invite/composables/validateInviteForm",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/authenticate/invite/composables/validateInviteForm.ts")
  },
  {
    name: "/pages/messages/[oid]/components/MessageDeliverabilityTab",
    path: "/messages/:oid()/components/MessageDeliverabilityTab",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/messages/[oid]/components/MessageDeliverabilityTab.vue")
  },
  {
    name: "/pages/audience/[customer]/view/customerProfileDataCapture",
    path: "/audience/:customer()/view/customerProfileDataCapture",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/customerProfileDataCapture.vue")
  },
  {
    name: "/pages/audience/[customer]/view/components/OrderDetailsModal",
    path: "/audience/:customer()/view/components/OrderDetailsModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/components/OrderDetailsModal.vue")
  },
  {
    name: "/pages/audience/[customer]/view/components/SelectDateRangeModal",
    path: "/audience/:customer()/view/components/SelectDateRangeModal",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/audience/[customer]/view/components/SelectDateRangeModal.vue")
  },
  {
    name: "/pages/events/components/view/ticket-sales/EventTicketSalesChart",
    path: "/events/components/view/ticket-sales/EventTicketSalesChart",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/view/ticket-sales/EventTicketSalesChart.vue")
  },
  {
    name: "/pages/events/components/view/ticket-sales/EventTicketTypesChart",
    path: "/events/components/view/ticket-sales/EventTicketTypesChart",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/view/ticket-sales/EventTicketTypesChart.vue")
  },
  {
    name: "/pages/events/components/view/ticket-sales/EventTicketSalesOverview",
    path: "/events/components/view/ticket-sales/EventTicketSalesOverview",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/view/ticket-sales/EventTicketSalesOverview.vue")
  },
  {
    name: "/pages/events/components/view/ticket-sales/EventTicketSalesAttribution",
    path: "/events/components/view/ticket-sales/EventTicketSalesAttribution",
    meta: {"middleware":["authenticated-client"]},
    component: () => import("/opt/build/repo/client/pages/events/components/view/ticket-sales/EventTicketSalesAttribution.vue")
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/audience/:customer/view/overview",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  }
]